import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { routePath } from 'app/services/helpers'
import axios from 'app/services/http/axios';

import {Actions} from './slice';
import { Api } from 'modules/Admin/Employees'

function* getEmployee({payload: {id}}) {
  try {
    const route = routePath(Api.employee, { id })

    const response = yield call(axios.get, route);
    yield put(Actions.getEmployeeSuccess(response));

  } catch (e) {
    return yield put(Actions.getEmployeeFailed(e));
  }
}

function* save({ payload: {id, values} }) {

  try {

    if ( id === 0 ) id = 'create'
    const route = routePath(Api.employee, { id })

    let response
    // If values is already a FormData (built by the form), send it directly
    if (values instanceof FormData) {
      response = yield call(axios.post, route, values)
    } else {
      const formData = new FormData();
      Object.keys(values).forEach(key => {
        const val = values[key]
        if (val instanceof File || val instanceof Blob) {
          formData.append(key, val)
        } else if (val instanceof Date) {
          formData.append(key, val.toISOString())
        } else if (typeof val === 'object' && val !== null) {
          formData.append(key, JSON.stringify(val))
        } else if (val !== undefined) {
          // append even empty strings
          formData.append(key, val)
        }
      })

      response = yield call(axios.post, route, formData);
    }

    yield put(Actions.saveFormSuccess(response));

    toast.success('Employee has been successfully saved')

  } catch (e) {
    return yield put(Actions.saveFormFailed(e));
  }
}

export function* watchEmployeesFormSaga() {
  yield takeLatest(Actions.getEmployee.type, getEmployee)
  yield takeLatest(Actions.saveForm.type, save)
}

export default watchEmployeesFormSaga
